import { IconBuildingBank, IconHistory, IconLayersLinked } from '@tabler/icons-react';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useMemo } from 'react';

import type { Menu } from '../types';

export function useBuildBankAccountMenu(): Menu {
  const { t } = useTranslation();
  const company = useCompanyConfiguration();

  return useMemo<Menu>(() => {
    const items = [
      {
        path: '/payments/reconciliation',
        label: t(i18nKeys.NAV.RECONCILIATION),
        Icon: IconLayersLinked,
      },
      {
        path: '/payments/history',
        label: t(i18nKeys.NAV.PAYMENT_BOOK),
        Icon: IconHistory,
      },
    ];

    return {
      parent: null,
      label: t(i18nKeys.COMMON.BANK_ACCOUNT),
      Icon: IconBuildingBank,
      isHidden: company?.banking_method === 'no_bank',
      path: '/payments/reconciliation',
      items,
    };
  }, [company, t]);
}
